module.exports = __webpack_public_path__ + "50ab8c2e363518578b400d07a61d03b2.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/line-naiyou.png
// module id = 231
// module chunks = 30